import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import {
  CustomResultOfPaginatedListOfGetPrivateNumberPricesWithPaginationDto,
  GetEnumValuesDto,
  GetPrivateNumberPriceByIdDto,
} from './../../../core/api/models';
import { GetPrivateNumberPricesWithPaginationDto } from './../../../core/api/models/get-private-number-prices-with-pagination-dto';
import { PaginatedListOfGetPrivateNumberPricesWithPaginationDto } from './../../../core/api/models/paginated-list-of-get-private-number-prices-with-pagination-dto';
import { PrivateNumberPriceService } from './../../../core/api/services/private-number-price.service';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { RefreshMenuService } from './../../../core/services/refresh-menu.service';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { PrivateNumbersPriceFormComponent } from './private-numbers-price-form/private-numbers-price-form.component';


@Component({
    selector: 'app-private-numbers-price',
    templateUrl: './private-numbers-price.component.html',
    styleUrls: ['./private-numbers-price.component.scss'],
    imports: [
        BaseIndexModule,
        PrivateNumbersPriceFormComponent,
    ]
})
export class PrivateNumbersPriceComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties
  pageName = PageNames.privateNumbersPrice;
  title = 'pages.privateNumbersPrice.title';
  protected currentService = inject(PrivateNumberPriceService);
  paginationApiMethodName: string = this.currentService.privateNumberPriceGetPrivateNumberPricesWithPagination.name;
  createGetApiMethodName: string = this.currentService.privateNumberPriceCreateGet.name;
  auditApiMethodName: string = this.currentService.privateNumberPriceGetPrivateNumberPricesAuditWithPagination.name;
  modelWithPagination$: Observable<PaginatedListOfGetPrivateNumberPricesWithPaginationDto>;
  items$: Observable<Array<GetPrivateNumberPricesWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetPrivateNumberPriceByIdDto> = {};
  SmsCpEnumValues: GetEnumValuesDto[] = [];
  //#endregion

  constructor(
    public refreshMenuService: RefreshMenuService
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  configTableColumns(): void {
    this.tableColumns = [
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: this.localizer.price,
        name: 'price',
        hasSearch: true,
        needCurrency: true,
        type: 'number',
      },
      {
        title: `common.smsCp`,
        name: 'smsCp',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsCp',
      },
      {
        title: `${this.tableVocabs}numberOfDigits`,
        name: 'numberOfDigits',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}reservationPeriod`,
        name: 'reservationPeriod',
        hasSearch: true,
        type: 'number',
      },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}isRound`,
        name: 'isRound',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .privateNumberPriceUpdateGet({
        Id: id,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .privateNumberPriceDelete({
        body: { id: id },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion
}
